import { useContext, useMemo } from 'react';

import FeatureFlagsContext, { type FeatureFlagsContextType } from './Context';

/**
 * @deprecated: Please use PostHog for feature flags. The hook to use for PostHog feature flags is `useFeatureFlagEnabled`, `useFeatureFlagPayload`, or `useFeatureFlagVariantKey`, depending on the situation.
 */
const useFeatureFlag = (
  featureFlagKey: Parameters<FeatureFlagsContextType['checkFeatureFlag']>[0],
  data?: Parameters<FeatureFlagsContextType['checkFeatureFlag']>[1],
): boolean => {
  const { checkFeatureFlag } = useContext(FeatureFlagsContext);

  const value = useMemo(() => checkFeatureFlag(featureFlagKey, data), [checkFeatureFlag, data, featureFlagKey]);

  return value;
};

export default useFeatureFlag;
